import React, { useEffect, useState } from 'react';
import { View } from '../../../app-components';
import {
  crossIconPng,
  squareCloseFillIcon,
  squareCloseIcon,
} from '../../../images';
import { Image } from '@applane/react-core-components';
import ReactTooltip from 'react-tooltip';
import { invoke } from '../../../AppServices';

const theme = {
  boxToHoldEverything: {
    padding: '2px 0px',
    width: 'inherit',
    overflowY: 'scroll',
    marginLeft: 10,
  },

  boxToHoldElement: {
    fontSize: 20,
    margin: 10,
    backgroundColor: 'white',
  },

  boxToHoldTitle: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    flexDirection: 'row',
    fontSize: 24,
    padding: '10px 0px',
    borderBottom: '1px solid black ',
  },

  boxToHoldX: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '0px 15px',
    cursor: 'pointer',
    width: 20,
    height: 20,
  },

  boxToHoldXInvisible: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '0px 15px',
    visibility: 'hidden',
  },

  boxToHoldEmpty: {
    height: '90%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    fontSize: 20,
    color: 'grey',
  },

  boxToHoldMakerName: {
    borderTop: '1px solid black',
    borderBottom: '1px solid black',
    paddingTop: '10px',
    display: 'flex',
    flexDirection: 'column',
    cursor: 'pointer',
  },

  boxToHoldMakerNameHover: {
    borderTop: '1px solid black',
    borderBottom: '1px solid black',
    paddingTop: '10px',
    display: 'flex',
    flexDirection: 'column',
    cursor: 'pointer',
    backgroundColor: 'rgba(236,240,241,1)',
  },

  xIconProperties: {
    width: 'inherit',
    height: 'inherit',
  },
};

const generateList = (data) => {
  let arr = [];
  for (let i = 0; i < data.length; i++) {
    arr.push(<li style={theme.boxToHoldElement}>{data[i]}</li>);
  }

  return (
    <ul
      style={{
        overflowY: 'scroll',
        listStyleType: 'square',
        backgroundColor: 'white',
      }}>
      {arr}
    </ul>
  );
};

const generateEmptyList = () => {
  return <View style={theme.boxToHoldEmpty}>No Data Available...</View>;
};

const YearList = (props) => {
  const { title, item } = props?.navigation?.state?.params;
  const [data, setData] = useState([]);
  const [xHover, setXHover] = useState(false);

  const getRangeData = async (fromYear, toYear) => {
    const { result } = await invoke({
      id: 'yearsInRange',
      paramValue: { fromYear, toYear },
    });

    setData(result);
  };

  useEffect(() => {
    const { carDetails, textYear, fromYear, toYear } = item;

    let y = [];

    if (carDetails === 'Any') {
      y.push('Any');
    } else if (carDetails === 'Enter Manually') {
      y.push(textYear);
    } else {
      console.log('select as per data conditon hit');
      getRangeData(fromYear, toYear);
    }
    setData(y);
  }, []);

  return (
    <>
      <ReactTooltip
        place="bottom"
        type="dark"
        effect="float"
        id="list-close-button"
      />
      <View style={theme.boxToHoldTitle}>
        <View style={theme.boxToHoldXInvisible}>
          <Image source={crossIconPng} />
        </View>
        {title}
        <div data-tip={'Close'} data-for={'list-close-button'}>
          <View
            style={theme.boxToHoldX}
            onMouseOver={() => {
              setXHover(true);
            }}
            onMouseLeave={() => {
              setXHover(false);
            }}
            onClick={() => {
              props.navigation.pop();
            }}>
            <Image
              source={xHover ? squareCloseFillIcon : squareCloseIcon}
              style={theme.xIconProperties}
            />
          </View>
        </div>
      </View>
      {item.length === 0 ? generateEmptyList() : generateList(data)}
    </>
  );
};

export default YearList;
